module.exports = __webpack_public_path__ + "static/img/location-setting.619d721.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/location-setting.svg
// module id = j+Tx
// module chunks = 1